export { default } from "./ActivityFunctionInfo";
